import React, { useState } from 'react';
import { FadeIn } from './Shared';
import { Plus, Minus } from 'lucide-react';
const AccordionItem = ({
  question,
  answer
}: {
  question: string;
  answer: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-white/5 last:border-0" data-id="element-70">
      <button className="w-full py-8 flex items-center justify-between text-left focus:outline-none" onClick={() => setIsOpen(!isOpen)} data-id="element-71">
        <span className={`text-lg md:text-xl font-bold transition-colors duration-300 pr-8 font-sans leading-snug ${isOpen ? 'text-orange-400' : 'text-white'}`} data-id="element-72">
          {question}
        </span>
        <div className={`w-8 h-8 rounded-full flex items-center justify-center transition-all duration-300 shrink-0 ${isOpen ? 'bg-orange-500 text-navy-950 rotate-180' : 'bg-white/5 text-orange-400'}`} data-id="element-73">
          {isOpen ? <Minus className="w-4 h-4" data-id="element-74" /> : <Plus className="w-4 h-4" data-id="element-75" />}
        </div>
      </button>
      <div className={`overflow-hidden transition-all duration-500 ease-in-out ${isOpen ? 'max-h-[500px] pb-8 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-76">
        <p className="text-gray-200 leading-relaxed text-base md:text-lg font-sans opacity-95 border-l-2 border-orange-500/30 pl-6 py-2" data-id="element-77">
          {answer}
        </p>
      </div>
    </div>;
};
export const FAQ = () => {
  const faqs = [{
    q: '¿Funciona para mi raza específica? Tengo un Husky / Beagle / Border Collie.',
    a: 'El sistema está diseñado sobre los principios de aprendizaje asociativo canino, que son los mismos para todas las razas. Las razas de alta energía cognitiva o vocales por naturaleza simplemente requieren más densidad en la parte de ocupación (Tomo 3) y a veces más tiempo en la escalada del Tomo 5. El Tomo 3 tiene una sección específica por perfil de perro incluyendo las razas más desafiantes.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Al confirmar el pago por Mercado Pago, recibís un email con acceso a todos los PDFs en menos de 5 minutos. Podés abrirlos en el celular, la tablet o la computadora. No necesitás imprimir nada.'
  }, {
    q: '¿Qué lo diferencia de los consejos gratuitos de Instagram?',
    a: 'Los consejos sueltos dan una técnica sin contexto. El Método Silencio Total es un sistema de 5 capas que trabaja el protocolo de salida, el ambiente, la ocupación, la nutrición y la escalada de forma integrada. Sin las 5 capas activas al mismo tiempo, los resultados son parciales o no se sostienen. Eso explica por qué "probaste de todo" y nada duró.'
  }, {
    q: '¿Funciona si mi perro tiene muchos años con este comportamiento?',
    a: 'Sí. El aprendizaje asociativo no desaparece con la edad. Los perros con ansiedad de separación crónica larga necesitan más tiempo de consolidación pero el sistema funciona igual. El Tomo 5 tiene un caso específico de un perro de 6 años con 4 años de ansiedad crónica sin intervención que llegó al Nivel 6 en 11 semanas.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días completos. Si abrís los tomos, los aplicás y no es lo que esperabas, te devolvemos el 100% sin ninguna pregunta. La tasa de devoluciones es menor al 1%.'
  }];
  return <section className="py-16 md:py-24 px-4 bg-navy-950 relative overflow-hidden pt-[32px] pb-[32px]" data-id="element-78">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-79">
        <FadeIn data-id="element-80">
          <div className="flex flex-col items-center mb-16" data-id="element-81">
            <div className="bg-white/5 text-gray-400 px-6 py-2 rounded-full border border-white/10 text-xs font-bold tracking-[0.2em] mb-6 uppercase" data-id="element-82">
              DESPEJÁ TUS DUDAS
            </div>
            <h2 className="text-3xl md:text-5xl text-center text-white leading-tight font-[900] font-[Montserrat,_sans-serif]" data-id="element-83">
              ❓ LO QUE MÁS NOS PREGUNTAN
            </h2>
          </div>
          <div className="bg-navy-950 rounded-3xl border border-white/10 p-8 md:p-12" data-id="element-84">
            {faqs.map((faq, index) => <AccordionItem key={index} question={faq.q} answer={faq.a} data-id="element-85" />)}
          </div>
        </FadeIn>
      </div>
    </section>;
};